if (!customElements.get("s-main-product")) {
  customElements.define(
    "s-main-product",
    class SectionMainProduct extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.sectionId = this.dataset.sectionId;

        window.PubSub.subscribe("variant:update", this.sectionUpdate);

        
        document.addEventListener('DOMContentLoaded', () => {
          
          this.initVariables();
       });
      }

      disconnectedCallback() {
        this.qtyButtonPlus?.removeEventListener('click', this.qtyButtonPlusClickHandler);
        this.qtyButtonMinus?.removeEventListener('click', this.qtyButtonMinusClickHandler);
        this.qtyInput?.removeEventListener('change', this.qtyInputChangeHandler);
        this.form?.removeEventListener("change", this.formHandler);
        this.form?.removeEventListener("submit", this.onSubmitHandler);
        this.calculatorObserver?.disconnect();
        this.calculatorObserver = null;
        if (Array.isArray(this.calculatorCleanups)) {
          this.calculatorCleanups.forEach((cleanup) => {
            try {
              cleanup();
            } catch (error) {
              console.warn("Calculator cleanup error", error);
            }
          });
          this.calculatorCleanups = [];
        }
      }

      initCalculator = () => {
        if (!this.calculatorId) return;

        this.calculatorCleanups = this.calculatorCleanups || [];

        const handleCalculatorReady = () => {
          const calculatorElement = document.getElementById(this.calculatorId);
          if (!calculatorElement) return false;

          this.calculatorElement = calculatorElement;
          this.calculatorObserver?.disconnect();
          this.calculatorObserver = null;
          if (Array.isArray(this.calculatorCleanups)) {
            this.calculatorCleanups.forEach((cleanup) => {
              try {
                cleanup();
              } catch (error) {
                console.warn("Calculator cleanup error", error);
              }
            });
            this.calculatorCleanups = [];
          }

          let heightValue = this.dataset.calculatorHeight;
          let widthValue = this.dataset.calculatorWidth;

          setTimeout(() => {
            const calculatorPrefillFields = {};
            const addPrefillField = (fieldId, value) => {
              if (!fieldId) return;
              if (value === undefined || value === null || value === "") return;
              calculatorPrefillFields[fieldId] = `${value}`;
            };

            const heightInput = document.querySelector(`#${this.dataset.calculatorHeightId}`);
            const widthInput = document.querySelector(`#${this.dataset.calculatorWidthId}`);
            const setCalculatorInputValue = (inputEl, value) => {
              if (!inputEl || value === undefined || value === null) return;
              const stringValue = `${value}`;
              
              this.simulateUserInput(inputEl, stringValue);
            };

            setCalculatorInputValue(heightInput, heightValue);
            setCalculatorInputValue(widthInput, widthValue);

            addPrefillField(this.dataset.calculatorHeightId, heightValue);
            addPrefillField(this.dataset.calculatorWidthId, widthValue);

            if (Object.keys(calculatorPrefillFields).length) {
              this.queueCalconicPrefill(calculatorPrefillFields);
            }

            const optionsSelect = document.querySelector(
              `#${this.dataset.calculatorVariantId} .rc-select-selection.rc-select-selection--single[aria-controls]`
            );

            const optionSelectId = optionsSelect?.getAttribute("aria-controls");

            if (!optionsSelect || !optionSelectId) {
              console.warn("Calculator variant select not found", { optionsSelect, optionSelectId });
              return;
            }

            optionsSelect.click();
            const optionSelectCustomRoot = document.querySelector(`.rc-select-dropdown:has(div[id="${optionSelectId}"])`);
            optionSelectCustomRoot.classList.add("rc-select-dropdown-hidden")
            console.log(optionSelectCustomRoot)

            if (!optionSelectCustomRoot) {
              console.warn("Calculator variant dropdown not found", optionSelectId);
              return;
            }

            const optionsSelectCustom = Array.from(
              optionSelectCustomRoot.querySelectorAll('[role="option"], .rc-select-item-option, li')
            );

            const packOptionLabels = (this.packOptions || [])
              .map((label) => label?.textContent?.trim())
              .filter(Boolean)
              .map((text) => text.toLowerCase());

            let preselectedOption = null;
            const optionClickHandlers = [];

            if (packOptionLabels.length === 0) {
              console.warn("Pack options list is empty; calculator dropdown will remain unchanged");
            } else {
              optionsSelectCustom.forEach((optionEl) => {
                if (!optionEl) return;

                const optionText = optionEl.textContent?.trim();
                if (!optionText) return;

                const normalizedText = optionText.toLowerCase();
                const matchesPackOption = packOptionLabels.includes(normalizedText);

                if (matchesPackOption) {
                  optionEl.style.removeProperty("display");
                  if (this.selectedPackOptionValue && normalizedText === this.selectedPackOptionValue) {
                    preselectedOption = optionEl;
                  }
                } else {
                  optionEl.style.display = "none";
                }

                const handleOptionClick = () => {
                  const packLabel = (this.packOptions || []).find((label) => {
                    const labelText = label?.textContent?.trim()?.toLowerCase();
                    return labelText === normalizedText;
                  });

                  if (packLabel) {
                    const packInput = packLabel.querySelector("input[name='Pack']");
                    if (!packInput?.checked) {
                      packLabel.click();
                    }
                  } else {
                    console.warn("Matching pack option not found for calculator option", optionText);
                  }
                };

                optionEl.addEventListener("click", handleOptionClick);
                optionClickHandlers.push({ element: optionEl, handler: handleOptionClick });
              });
            }
            
            if (preselectedOption) {
              preselectedOption.click();
            } else if (this.selectedPackOptionValue) {
              console.warn("Selected pack option not found in calculator dropdown", this.selectedPackOptionValue);
            }

            if (optionClickHandlers.length) {
              this.calculatorCleanups = this.calculatorCleanups || [];
              this.calculatorCleanups.push(() => {
                optionClickHandlers.forEach(({ element, handler }) => {
                  try {
                    element.removeEventListener("click", handler);
                  } catch (error) {
                    console.warn("Failed to remove calculator option handler", { element, error });
                  }
                });
              });
            }
          }, 1000);

          return true;
        };

        if (handleCalculatorReady()) return;

        this.calculatorObserver?.disconnect();

        this.calculatorObserver = new MutationObserver(() => {
          if (handleCalculatorReady()) {
            this.calculatorObserver?.disconnect();
            this.calculatorObserver = null;
          }
        });

        this.calculatorObserver.observe(document.body, {
          childList: true,
          subtree: true,
        });
      }

      tryInvokeCalconicPrefill = (api, id, fields) => {
        if (typeof api !== "function" || !id || !fields) return false;

        const attemptCalls = [
          () => api("prefill", { id, fields }),
          () =>
            api("calculator", id, "setFieldValue", fields) ||
            Object.entries(fields).forEach(([fieldId, fieldValue]) => api("calculator", id, "setFieldValue", fieldId, fieldValue)),
          () => api("calculator", id, "prefill", fields),
        ];

        for (const invoke of attemptCalls) {
          try {
            const result = invoke();
            if (result !== false) return true;
          } catch (_error) {
            continue;
          }
        }

        return false;
      };

      queueCalconicPrefill = (fields, attempt = 0) => {
        if (!this.calculatorId || !fields || typeof fields !== "object") return false;

        const normalizedId = this.calculatorId.replace(/^lumi-calculator-/, "");
        if (!normalizedId) return false;

        const maxAttempts = 8;
        const scheduleRetry = () => {
          if (attempt >= maxAttempts) {
            console.warn("Calconic API not ready after retries; skipping prefill", {
              calculatorId: this.calculatorId,
              fields,
            });
            return;
          }

          const timeoutId = window.setTimeout(() => {
            this.queueCalconicPrefill(fields, attempt + 1);
          }, 250);

          this.calculatorCleanups.push(() => window.clearTimeout(timeoutId));
        };

        const calconicFn = typeof window.calconic === "function" ? window.calconic : null;
        const calconicFnAlt = typeof window.Calconic === "function" ? window.Calconic : null;

        const invokeSucceeded =
          this.tryInvokeCalconicPrefill(calconicFn, normalizedId, fields) ||
          this.tryInvokeCalconicPrefill(calconicFnAlt, normalizedId, fields);

        if (invokeSucceeded) {
          return true;
        }

        if (!calconicFn && !calconicFnAlt) {
          scheduleRetry();
          return false;
        }

        try {
          const queue = window.CalconicQueue = window.CalconicQueue || [];
          queue.push(() => {
            if (this.tryInvokeCalconicPrefill(window.calconic, normalizedId, fields)) return;
            if (this.tryInvokeCalconicPrefill(window.Calconic, normalizedId, fields)) return;
          });
          return this.tryInvokeCalconicPrefill(calconicFn || calconicFnAlt, normalizedId, fields);
        } catch (error) {
          console.warn("Calconic prefill failed", error);
          scheduleRetry();
          return false;
        }
      };

      dispatchSafeEvent = (element, type, options = {}, Constructor = Event) => {
        if (!element) return false;
        let event;
        const eventOptions = { bubbles: true, cancelable: true, composed: true, ...options };
        const EventCtor = typeof Constructor === "function" ? Constructor : Event;
        try {
          event = new EventCtor(type, eventOptions);
        } catch (_error) {
          try {
            event = document.createEvent("Event");
            event.initEvent(type, eventOptions.bubbles, eventOptions.cancelable);
          } catch (error) {
            console.warn("Failed to dispatch synthetic event", { type, error });
            return false;
          }
        }

        try {
          element.dispatchEvent(event);
          return true;
        } catch (error) {
          console.warn("Synthetic event dispatch failed", { type, error });
          return false;
        }
      };

      simulatePointerInteraction = (element) => {
        if (!element) return;

        const pointerOptions = { bubbles: true, cancelable: true, composed: true, pointerId: 1, pointerType: "mouse" };
        const pointerCtor = typeof PointerEvent === "function" ? PointerEvent : MouseEvent;
        const mouseCtor = typeof MouseEvent === "function" ? MouseEvent : Event;
        const focusCtor = typeof FocusEvent === "function" ? FocusEvent : Event;

        const pointerEvents = [
          ["pointerover", pointerCtor],
          ["pointerenter", pointerCtor],
          ["mouseover", mouseCtor],
          ["mouseenter", mouseCtor],
          ["pointerdown", pointerCtor],
          ["mousedown", mouseCtor],
        ];

        pointerEvents.forEach(([type, Constructor]) => {
          try {
            this.dispatchSafeEvent(element, type, pointerOptions, Constructor);
          } catch (_error) {
            this.dispatchSafeEvent(element, type, pointerOptions, mouseCtor);
          }
        });

        if (typeof element.focus === "function") {
          try {
            element.focus({ preventScroll: true });
          } catch (_error) {
            element.focus();
          }
        }

        this.dispatchSafeEvent(element, "focus", { bubbles: false, cancelable: false }, focusCtor);
      };

      simulateUserInput = (inputEl, value) => {
        if (!inputEl) return;

        const stringValue = value === undefined || value === null ? "" : `${value}`;
        this.simulatePointerInteraction(inputEl);

        const currentValue = inputEl.value ?? "";

        if (typeof inputEl.select === "function") {
          try {
            inputEl.select();
          } catch (_error) {
            if (typeof inputEl.setSelectionRange === "function") {
              try {
                inputEl.setSelectionRange(0, currentValue.length);
              } catch (error) {
                console.warn("Failed to set selection range", error);
              }
            }
          }
        }

        const applyValue = (nextValue, inputType) => {
          const nativeSetter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, "value")?.set;
          if (nativeSetter) {
            // nativeSetter.call(inputEl, nextValue);
          } else {
            inputEl.value = nextValue;
          }
          inputEl.setAttribute("value", nextValue);
          if ("defaultValue" in inputEl) {
            inputEl.defaultValue = nextValue;
          }

          this.dispatchSafeEvent(
            inputEl,
            "input",
            { data: nextValue, inputType: inputType ?? "insertReplacementText" },
            typeof InputEvent === "function" ? InputEvent : Event
          );
        };

        if (currentValue !== stringValue) {
          if (currentValue) {
            applyValue("", "deleteContentBackward");
          }
          applyValue(stringValue, "insertReplacementText");
        } else {
          applyValue(stringValue, "insertText");
        }

        this.dispatchSafeEvent(
          inputEl,
          "keyup",
          { key: "Enter", code: "Enter" },
          typeof KeyboardEvent === "function" ? KeyboardEvent : Event
        );

        this.dispatchSafeEvent(inputEl, "change");
        this.dispatchSafeEvent(
          inputEl,
          "blur",
          { bubbles: false, cancelable: false },
          typeof FocusEvent === "function" ? FocusEvent : Event
        );
        this.dispatchSafeEvent(
          inputEl,
          "pointerup",
          { pointerId: 1, pointerType: "mouse" },
          typeof PointerEvent === "function" ? PointerEvent : MouseEvent
        );
        this.dispatchSafeEvent(inputEl, "mouseup", {}, typeof MouseEvent === "function" ? MouseEvent : Event);
        this.dispatchSafeEvent(inputEl, "click", {}, typeof MouseEvent === "function" ? MouseEvent : Event);
      };

      initVariables = () => {
        this.qtyInput = this.querySelector('.js-main-product__form-qty-input');
        this.qtyButtonPlus = this.querySelector('.js-main-product__form-qty-button--plus');
        this.qtyButtonMinus = this.querySelector('.js-main-product__form-qty-button--minus');
        
        this.qtyButtonPlus?.addEventListener('click', this.qtyButtonPlusClickHandler);
        this.qtyButtonMinus?.addEventListener('click', this.qtyButtonMinusClickHandler);
        this.qtyInput?.addEventListener('change', this.qtyInputChangeHandler);
        this.qtyInput?.addEventListener('input', this.qtyInputChangeHandler);

        this.form = this.querySelector(".js-main-product__form") || null;

        this.submitBtn = this.querySelector(".js-main-product__form-submit") || null;

        this.form?.addEventListener("submit", this.onSubmitHandler);

        this.variantPickerForm = this.querySelector(".s-main-product__variant-picker") || null;

        this.variantPickerForm?.addEventListener("change", this.formHandler);

        this.packOptions = Array.from(this.querySelectorAll("label:has(input[name='Pack'])"));

        const selectedPackLabel = this.packOptions.find((label) => {
          const input = label.querySelector("input[name='Pack']");
          return input?.checked;
        });

        const selectedPackText = selectedPackLabel?.textContent?.trim() || null;
        this.selectedPackOptionText = selectedPackText;
        this.selectedPackOptionValue = selectedPackText?.toLowerCase() || null;
        this.calculatorId = this.dataset.calculatorId || null;
        if (this.calculatorId) this.initCalculator();
      }

      disabledEvents = () => {
        this.qtyButtonPlus?.removeEventListener('click', this.qtyButtonPlusClickHandler);
        this.qtyButtonMinus?.removeEventListener('click', this.qtyButtonMinusClickHandler);
        this.qtyInput?.removeEventListener('change', this.qtyInputChangeHandler);
        this.qtyInput?.removeEventListener('input', this.qtyInputChangeHandler);
        this.variantPickerForm?.removeEventListener("change", this.formHandler);
        this.form?.removeEventListener("submit", this.onSubmitHandler);
      }

      sectionUpdate = (url) => {
        this.classList.add("is-loading");

        fetch(url + "&section_id=" + this.sectionId)
          .then((response) => response.text())
          .then((html) => {

            this.disabledEvents();

            let newSection = document.createElement("div");
            newSection.innerHTML = html;

            let newComponent = newSection.querySelector(".s-main-product");
            
            if (newComponent) {
              this.querySelector(".s-main-product__blocks").innerHTML = newComponent.querySelector(".s-main-product__blocks").innerHTML;
            }

            window.history.pushState({}, "", url);
            this.initVariables();
            this.classList.remove("is-loading");
          })
          .catch((error) => console.error(error));
      };

      getCartComponent = () => {
        if (!this.cartComponent || !document.body.contains(this.cartComponent)) {
          this.cartComponent = document.querySelector("cart-drawer") || document.querySelector("cart-notification") || null;
        }

        return this.cartComponent;
      }

      appendSectionsToFormData = (formData) => {
        const cartComponent = this.getCartComponent();

        if (cartComponent?.getSectionsToRender) {
          const sections = cartComponent
            .getSectionsToRender()
            .map((section) => section.id || section.section)
            .filter(Boolean);

          if (sections.length) {
            formData.append("sections", sections);
            formData.append("sections_url", window.location.pathname);
            cartComponent.setActiveElement?.(document.activeElement);
          }
        }
      }

      handleCartSuccess = (response) => {
        const cartComponent = this.getCartComponent();

        if (cartComponent?.renderContents) {
          cartComponent.classList?.remove("is-empty");
          cartComponent.renderContents(response);
        } else {
          window.location.href = `${window.Shopify.routes.root}cart`;
        }
      }

      onSubmitHandler = (evt) => {
        evt.preventDefault();  
  
        const config = {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/javascript'
          }
        };
  
        let formData = new FormData(this.form);
        this.appendSectionsToFormData(formData);
        config.body = formData;

        this.submitBtn?.setAttribute("disabled", "")
  
        fetch(window.Shopify.routes.root + 'cart/add.js', config)
          .then((response) => response.json())
          .then((response) => {
            if (response?.status) {
              console.error('Add to cart error:', response);
              const errorMessage = response?.description || response?.message;
              if (errorMessage) {
                alert(errorMessage);
              }
              return;
            }

            this.handleCartSuccess(response);

            setTimeout(() => {
              window.PubSub.publish('cart-modal:open');
            },1)
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitBtn?.removeAttribute("disabled")
          });
      }

      formHandler = (event) => {
        if(event.target.getAttribute("name") === "quantity") return

        let url = event.target.options ? event.target.options[event.target.options.selectedIndex].dataset.variantUrl : event.target.dataset.variantUrl;

        window.PubSub.publish("variant:update", url);
      }

      qtyInputChangeHandler = () => {
        const min = parseInt(this.qtyInput.min, 10);
        const max = parseInt(this.qtyInput.max, 10);
        let value = parseInt(this.qtyInput.value, 10);

        if (Number.isNaN(value)) {
          value = Number.isNaN(min) ? 1 : min;
        }

        if (value <= 0) {
          value = Number.isNaN(min) ? 1 : Math.max(min, 1);
        }

        if (!Number.isNaN(max) && value > max) {
          value = max;
        }

        if (!Number.isNaN(min) && value < min) {
          value = min;
        }

        this.qtyInput.value = `${value}`;

        if (!Number.isNaN(max) && value === max) {
          this.qtyButtonPlus.classList.add('s-main-product__form-qty-button--disabled')
        } else {
          this.qtyButtonPlus.classList.remove('s-main-product__form-qty-button--disabled')
        }

        if (!Number.isNaN(min) && value === min) {
          this.qtyButtonMinus.classList.add('s-main-product__form-qty-button--disabled')
        } else {
          this.qtyButtonMinus.classList.remove('s-main-product__form-qty-button--disabled')
        }
      }

      qtyButtonPlusClickHandler = () => {
        this.qtyInput.value = parseInt(this.qtyInput.value, 10) + 1
  
        this.qtyInput.dispatchEvent(new Event('change'))
      }
  
      qtyButtonMinusClickHandler = () => {
        this.qtyInput.value = parseInt(this.qtyInput.value, 10) - 1
  
        this.qtyInput.dispatchEvent(new Event('change'))
      }
    }
  );
}
